// Configuration loaded from environment variables
const config = {
  oktaClientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  oktaIssuerUrl: process.env.REACT_APP_OKTA_ISSUER_URL,
  oktaBaseUri: process.env.REACT_APP_OKTA_BASE_URI,
  oktaSigninRedirectUrl: process.env.REACT_APP_OKTA_SIGNIN_REDIRECT_URL,
  oktaScopes: process.env.REACT_APP_OKTA_SCOPES
    ? process.env.REACT_APP_OKTA_SCOPES.split(",")
    : ["openid", "profile", "email", "groups", "offline_access"],
  apiUrl: process.env.REACT_APP_API_URL,
  AutoHubURL: process.env.REACT_APP_AUTO_HUB_URL,
  languages: process.env.REACT_APP_LANGUAGES
    ? process.env.REACT_APP_LANGUAGES.split(",").map((lang) => {
        const [value, text] = lang.split(":");
        return { value, text };
      })
    : [
        { value: "en", text: "English" },
        { value: "es", text: "Español" },
      ],
};

export default config;

// Load function now returns a resolved promise since config is already loaded from env vars
function load() {
  return Promise.resolve(config);
}

export { load };
